<template>
  <div class="container col-10">
    <v-dialog
      v-model="dialogStart"
      fullscreen
      hide-overlay
      :retain-focus="false"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="secondary">
          <v-btn icon dark class="btn btn-primary" @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('starAssignment.template.massiveTitle') }}</v-toolbar-title>
        </v-toolbar>

        <div class="container mt-5">
          <v-tabs v-model="tab" background-color="transparent" color="#6e17a5" grow>
            <v-tab>{{ $t('starAssignment.template.tabSummary') }}</v-tab>
            <v-tab>{{ $t('starAssignment.template.tabNewUpload') }}</v-tab>
          </v-tabs>

          <v-alert
            v-if="processingJob"
            type="info"
            prominent
            class="mb-4"
          >
            <div class="d-flex align-center">
              <v-progress-circular
                indeterminate
                size="20"
                width="2"
                class="mr-3"
              />
              <span v-if="jobStatus && jobStatus.jobStatus === 0">{{ $t('starAssignment.template.pending') }}</span>
              <span v-else>{{ $t('starAssignment.template.processingFile') }}</span>
            </div>
          </v-alert>

          <v-tabs-items v-model="tab">
            <!-- Pestaña 1: Resumen (Tabla Histórica) -->
            <v-tab-item>
              <v-card class="step-card mt-4">
                <v-card-title class="step-header">
                  <span class="step-title">{{ $t('starAssignment.template.historicalTitle') }}</span>
                </v-card-title>
                <v-card-text>
                  <div v-if="loading" class="text-center py-3">
                    <v-progress-circular
                      :size="50"
                      :width="5"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                  <div v-else>
                    <v-text-field
                      :label="$t('label.search.title')"
                      :placeholder="$t('label.search.text')"
                      append-icon="mdi-magnify"
                      dense
                      outlined
                      class="mb-4"
                      @input="search"
                    ></v-text-field>

                    <v-data-table
                      :headers="headers"
                      :items="listHistoricalTemplateDispersal"
                      :header-props="{ class: 'red-header' }"
                      :search="searchTerm"
                      :no-data-text="$t('starAssignment.template.noDataAvailable')"
                      :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }"
                    >
                      <template v-slot:[`item.assigmentReportId`]="{ item }">
                        <span class="custom-font">{{ item.assigmentReportId }}</span>
                      </template>

                      <template v-slot:[`item.creationDate`]="{ item }">
                        <span class="custom-font">{{ formatDate(item.creationDate) }}</span>
                      </template>

                      <template v-slot:[`item.numberUsers`]="{ item }">
                        <span class="custom-font">{{ item.numberUsers }}</span>
                      </template>

                      <template v-slot:[`item.requestStatus`]="{ item }">
                       
                        
                          <span class="custom-font">{{ item.requestStatus }}</span>
                        
                      </template>

                      <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-large
                              dark
                              text
                              v-bind="attrs"
                              v-on="on"
                              color="primary"
                              @click="redirectToDownload(item.linkFile)"
                            >
                              <v-icon color="primary">mdi-download</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('starAssignment.template.download') }}</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Pestaña 2: Nuevo Cargue (Flujo Guiado) -->
            <v-tab-item>

              <v-alert
                v-if="processingJob"
                type="info"
                prominent
                class="mb-4"
              >
                <div class="d-flex align-center">
                  <v-progress-circular
                    indeterminate
                    size="20"
                    width="2"
                    class="mr-3"
                  />
                  <span v-if="jobStatus && jobStatus.jobStatus === 0">Pendiente...</span>
                  <span v-else>Procesando archivo. Esto puede tardar algunos segundos...</span>
                </div>
              </v-alert>

              <div class="mt-4">
                <!-- Banner Informativo -->
                <v-card class="banner-informativo mb-3" color="#eadcf3">
                  <v-card-text class="pa-3">
                    <div class="d-flex align-center">
                      <v-icon color="#6e17a5" class="mr-3">mdi-information</v-icon>
                      <div>
                        <h3 class="banner-title mb-1">{{ $t('starAssignment.template.bannerTitle') }}</h3>
                        <p class="banner-text mb-0">{{ $t('starAssignment.template.bannerText') }}</p>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <!-- Paso 1: Consultar Existencias -->
                <v-card class="step-card mb-3">
                  <v-card-title class="step-header">
                    <span class="step-number">1</span>
                    <span class="step-title">{{ $t('starAssignment.template.step1Title') }}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      rounded
                      small
                      @click="getCards"
                      :loading="loadingCards"
                      :disabled="processingJob"
                    >
                      <v-icon left small>mdi-refresh</v-icon>
                      {{ $t('starAssignment.template.updateStock') }}
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <p class="step-description">{{ $t('starAssignment.template.step1Description') }}</p>
                    <div v-if="loadingCards" class="text-center py-3">
                      <v-progress-circular
                        :size="50"
                        :width="5"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                    </div>
                    <v-row no-gutters v-else>
                      <v-col md="3" sm="6" class="pa-2" v-for="(item, i) in cards" :key="i">
                        <v-card :class="item.shapeCount === 0 ? 'cardStyle-gray' : 'cardStyle'">
                          <div class="d-flex flex-no-wrap justify-space-between">
                            <div>
                              <v-card-title style="font-size: 0.90rem; word-break: auto-phrase;">{{ item.categoryName }}</v-card-title>
                              <v-card-title class="text-h6">{{ item.shapeCount }}</v-card-title>
                            </div>
                            <v-avatar class="avatarStyle" size="48">
                              <div class="icon-item">
                                <img :src="item.icon" />
                              </div>
                            </v-avatar>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Indicador de progreso -->
                <div class="progress-indicator text-center mb-3">
                  <v-icon color="#6e17a5" small>mdi-arrow-down</v-icon>
                </div>

                <!-- Paso 2: Descargar Plantilla Actualizada -->
                <v-card class="step-card mb-3">
                  <v-card-title class="step-header">
                    <span class="step-number">2</span>
                    <span class="step-title">{{ $t('starAssignment.template.step2Title') }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-alert
                      type="warning"
                      colored-border
                      border="left"
                      class="mb-4"
                    >
                      <div class="alert-content">
                        <strong>{{ $t('starAssignment.template.important') }}</strong>
                        <p class="mb-2 mt-2">{{ $t('starAssignment.template.step2Warning1') }}</p>
                        <p class="mb-0">{{ $t('starAssignment.template.step2Warning2') }}</p>
                      </div>
                    </v-alert>
                    <div class="text-center">
                      <v-btn
                        large
                        rounded
                        color="primary"
                        dark
                        :loading="loadingDownload"
                        :disabled="processingJob"
                        @click="postDownloadTemplateRedirect()"
                      >
                        <v-icon left>mdi-download</v-icon>
                        {{ $t('starAssignment.template.downloadTemplate') }}
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>

                <!-- Indicador de progreso -->
                <div class="progress-indicator text-center mb-3">
                  <v-icon color="#6e17a5" small>mdi-arrow-down</v-icon>
                </div>

                <!-- Paso 3: Cargar Archivo -->
                <v-card class="step-card mb-3">
                  <v-card-title class="step-header">
                    <span class="step-number">3</span>
                    <span class="step-title">{{ $t('starAssignment.template.step3Title') }}</span>
                  </v-card-title>
                  <v-card-text>
                    <p class="step-description mb-4">{{ $t('starAssignment.template.step3Description') }}</p>
                    
                    <v-alert
                      type="info"
                      colored-border
                      border="left"
                      class="mb-4"
                    >
                      <div class="alert-content">
                        <p class="mb-1"><strong>{{ $t('starAssignment.template.acceptedFormats') }}</strong> .xls, .xlsx</p>
                        <p class="mb-0"><strong>{{ $t('starAssignment.template.maxSize') }}</strong> 50MB</p>
                      </div>
                    </v-alert>

                    <div 
                      class="upload-area"
                      :class="{ 'drag-over': isDragOver }"
                      @dragover.prevent="isDragOver = true"
                      @dragleave.prevent="isDragOver = false"
                      @drop.prevent="handleDrop"
                      @click="triggerFileInput"
                    >
                      <v-file-input
                        ref="fileInput"
                        v-model="fileModel"
                        accept=".xls,.xlsx"
                        @change="handleFileUpload"
                        :disabled="loadingUpload || processingJob"
                        hide-input
                        class="d-none"
                      ></v-file-input>
                      <div v-if="!fileModel" class="drop-zone-text">
                        <v-icon large color="#6e17a5">mdi-cloud-upload</v-icon>
                        <p class="mt-2 mb-0">{{ $t('starAssignment.template.dragDropText') }}</p>
                      </div>
                      <div v-else class="file-info">
                        <v-icon color="success">mdi-check-circle</v-icon>
                        <span class="ml-2">{{ fileModel.name }}</span>
                        <span class="ml-2 text-caption">({{ formatFileSize(fileModel.size) }})</span>
                      </div>
                    </div>

                    <div class="text-center mt-4">
                      <v-btn
                        large
                        rounded
                        color="primary"
                        dark
                        :disabled="!isFormValid || processingJob"
                        :loading="loadingUpload"
                        @click="postConfirm"
                      >
                        <v-icon left>mdi-upload</v-icon>
                        {{ $t('starAssignment.template.processFile') }}
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";

import {
  STARASSIGNMENT_M,
  GET_LIST_HISTORICAL_TEMPLATE,
  GET_DOWNLOAD_TEMPLATE,
  GET_STATE_LOADING,
  ACTION_GET_LIST_HISTORICAL_TEMPLATE,
  ACTION_POST_TEMPLATE,
  ACTION_DOWNLOAD_TEMPLATE,
  ACTION_GET_JOB_STATUS
} from "@/views/star_assignment/store/types/types.js";

import {
  RECOGNITION_BUYING_M,
  GET_CARDS,
  ACTION_GET_CARDS,
} from "@/views/recognition/store/types/types.js";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "detailReportComponent",
  props: {
    dialogStart: {
      required: true,
    },
  },

  data() {
    return {
      tab: 0,
      formData: {
        startDate: null,
        endDate: null,
        company: null,
        email: null,
      },
      searchTerm: "",
      fileModel: null,
      isFormValid: null,
      loadingCards: false,
      loadingDownload: false,
      loadingUpload: false,
      jobId: null,
      pollingInterval: null,
      jobStatus: null,
      processingJob: false,
      isDragOver: false,
    };
  },

  async mounted() {
    await this.getListHistoricalTemplate();
    await this.getCards();
  },

  beforeDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('starAssignment.template.table.confirmationCode'),
          value: "assigmentReportId",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('starAssignment.template.table.startDate'),
          value: "creationDate",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1 my-custom-font",
        },
        {
          text: this.$t('starAssignment.template.table.requestCount'),
          value: "numberUsers",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('starAssignment.template.table.processStatus'),
          value: "requestStatus",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },

    ...mapGetters({
      listHistoricalTemplateDispersal: `${STARASSIGNMENT_M}${GET_LIST_HISTORICAL_TEMPLATE}`,
      downloadTemplateDispersal: `${STARASSIGNMENT_M}${GET_DOWNLOAD_TEMPLATE}`,
      loading: `${STARASSIGNMENT_M}${GET_STATE_LOADING}`,
      cards: `${RECOGNITION_BUYING_M}${GET_CARDS}`,
    }),
  },

  methods: {
    ...mapActions({
      getJobStatus: `${STARASSIGNMENT_M}${ACTION_GET_JOB_STATUS}`,
    }),
    search() {
      this.searchTerm = event.target.value;
    },

    closeDialog() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
      this.processingJob = false;
      this.jobId = null;
      this.selectedFile = null;
      this.isFormValid = false;
      this.fileModel = null;
      this.dialogStart = false;
      window.location.reload();
    },

    handleFileUpload(file) {
      if (file) {
        this.isFormValid = true;
      } else {
        this.isFormValid = false;
      }

      const allowedTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];

      if (file && !allowedTypes.includes(file.type)) {
        Swal.fire({
          icon: "error",
          title: this.$t('starAssignment.template.invalidFormat'),
          text: this.$t('starAssignment.template.invalidFormatText')
        });
        this.isFormValid = false;
        return;
      }

      // Validar tamaño máximo de 50MB
      if (file && file.size > 50 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: this.$t('starAssignment.template.fileTooLarge'),
          text: this.$t('starAssignment.template.fileTooLargeText')
        });
        this.isFormValid = false;
        return;
      }

      this.selectedFile = file;
    },

    handleDrop(event) {
      this.isDragOver = false;
      const file = event.dataTransfer.files[0];
      if (file) {
        this.fileModel = file;
        this.handleFileUpload(file);
      }
    },

    triggerFileInput() {
      if (!this.loadingUpload && !this.processingJob) {
        this.$refs.fileInput.$el.querySelector('input[type="file"]').click();
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },

    async postConfirm() {
      try {
        this.loadingUpload = true;

        const formdata = new FormData();
        formdata.append("fileReport", this.selectedFile);

        const monetization = await this.postScatterStarsTemplates(formdata);

        this.selectedFile = null;
        this.loadingUpload = false;

        if (monetization) {

          const jobId = monetization.data?.payload?.jobId;

          if (jobId) {

            this.jobId = jobId;
            this.processingJob = true;

            Swal.fire({
              title: this.$t('starAssignment.template.processingFileTitle'),
              html: `
                <div>
                  <p>${this.$t('starAssignment.template.validatingInfo')}</p>
                  <p>${this.$t('starAssignment.template.pleaseWait')}</p>
                </div>
              `,
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });

            // Limpiar polling anterior si existe
            if (this.pollingInterval) {
              clearInterval(this.pollingInterval);
              this.pollingInterval = null;
            }

            this.startPolling();

          } else {

            await Swal.fire({
              title: this.$t('starAssignment.template.error'),
              text:
                monetization.data?.payload?.message ||
                monetization.payload?.message ||
                this.$t('starAssignment.template.processError'),
              icon: "error",
              confirmButtonText: this.$t('button.ok')
            });

          }
        }

      } catch (error) {

        // Algunos servicios devuelven 202 como excepción
        if (
          error &&
          error.status === 202 &&
          error.data &&
          error.data.payload &&
          error.data.payload.jobId
        ) {

          this.loadingUpload = false;

          this.jobId = error.data.payload.jobId;
          this.processingJob = true;

         

          Swal.fire({
            title: this.$t('starAssignment.template.processingFileTitle'),
            html: `
              <div>
                <p>${this.$t('starAssignment.template.validatingInfo')}</p>
                <p>${this.$t('starAssignment.template.pleaseWait')}</p>
              </div>
            `,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });

          if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
          }

          this.startPolling();
          return;
        }

        this.loadingUpload = false;

        await Swal.fire({
          title: this.$t('starAssignment.template.error'),
          text:
            error?.data?.payload?.message ||
            this.$t('starAssignment.template.processErrorMessage'),
          icon: "error",
          confirmButtonText: this.$t('button.ok')
        });
      }
    },

    startPolling() {
      // Polling cada 3 segundos
      this.pollingInterval = setInterval(async () => {
        try {
          const jobStatus = await this.getJobStatus(this.jobId);
          if (!jobStatus) {
            return;
          }
          this.jobStatus = jobStatus;

          // Manejar estados del job
          if (jobStatus.jobStatus === 2) {
            // Job listo - éxito
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            this.processingJob = false;
            
            let successMessage = this.$t('starAssignment.template.fileProcessedSuccess');
            if (jobStatus.linkFile) {
              successMessage += this.$t('starAssignment.template.fileAvailableHistorical');
            }
            
            await Swal.fire({
              title: this.$t('starAssignment.template.success'),
              text: successMessage,
              icon: "success",
              confirmButtonText: this.$t('button.ok')
            });
            await this.getListHistoricalTemplate();
            this.selectedFile = null;
            this.isFormValid = false;
            this.fileModel = null;
            // Redireccionar a la pestaña Resumen
            this.tab = 0;
            this.jobId = null;
          } else if (jobStatus.jobStatus === 3) {
            // Job falló - error
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
            this.processingJob = false;
            await Swal.fire({
              title: this.$t('starAssignment.template.error'),
              text: jobStatus.errorMessage.message || this.$t('starAssignment.template.processError'),
              icon: "error",
              confirmButtonText: this.$t('button.ok')
            });
            this.jobId = null;
            this.selectedFile = null;
            this.fileModel = null;
            this.isFormValid = false;
          }
          // Estados 0 (pendiente) y 1 (procesando) continúan el polling
        } catch (error) {
         
          clearInterval(this.pollingInterval);
          this.pollingInterval = null;
          this.processingJob = false;
          await Swal.fire({
            title: this.$t('starAssignment.template.error'),
            text: this.$t('starAssignment.template.statusError'),
            icon: "error",
            confirmButtonText: this.$t('button.ok')
          });
        }
      }, 3000); // Polling cada 3 segundos
    },

    redirectToDownload(link) {
      window.location.href = link;
    },

    async postDownloadTemplateRedirect() {
      try {
        this.loadingDownload = true;
        const link = await this.postDownloadTemplate();
        this.loadingDownload = false;
        
        if (link && link.data && link.data.payload) {
          this.redirectToDownload(link.data.payload);
        }
      } catch (error) {
        this.loadingDownload = false;
      }
    },

    formatDate(dateString) {
      return dateString.split("T")[0];
    },


    ...mapActions({
      getListHistoricalTemplate: `${STARASSIGNMENT_M}${ACTION_GET_LIST_HISTORICAL_TEMPLATE}`,
      postScatterStarsTemplates: `${STARASSIGNMENT_M}${ACTION_POST_TEMPLATE}`,
      postDownloadTemplate: `${STARASSIGNMENT_M}${ACTION_DOWNLOAD_TEMPLATE}`,
      getCards: `${RECOGNITION_BUYING_M}${ACTION_GET_CARDS}`,
    }),
  },
};
</script>

<style lang="css" scoped>
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

.container {
  position: relative;
}

/* Tabs Styles */
::v-deep .v-tabs {
  border-bottom: 2px solid #6e17a5;
}

::v-deep .v-tab {
  font-family: "Nunito Sans", sans-serif;
  color: #2d0049;
  font-weight: 600;
  text-transform: none;
  font-size: 16px;
}

::v-deep .v-tab--active {
  color: #6e17a5;
}

::v-deep .v-tabs-slider {
  background-color: #6e17a5;
}

/* Banner Informativo */
.banner-informativo {
  border-radius: 12px;
  border: 2px solid #6e17a5;
}

.banner-title {
  font-family: "Amsi Pro", sans-serif;
  color: #6e17a5;
  font-size: 18px;
  font-weight: bold;
}

.banner-text {
  font-family: "Nunito Sans", sans-serif;
  color: #2d0049;
  font-size: 14px;
}

/* Step Cards */
.step-card {
  border-radius: 12px;
  border: 2px solid #6e17a5;
}

.step-header {
  background-color: #eadcf3;
  padding: 12px;
  display: flex;
  align-items: center;
}

.step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: #6e17a5;
  color: white;
  border-radius: 50%;
  font-size: 18px;
  font-weight: bold;
  margin-right: 12px;
  font-family: "Nunito Sans", sans-serif;
}

.step-title {
  font-family: "Amsi Pro", sans-serif;
  color: #6e17a5;
  font-size: 16px;
  font-weight: bold;
}

.step-description {
  font-family: "Nunito Sans", sans-serif;
  color: #2d0049;
  font-size: 14px;
}

/* Progress Indicator */
.progress-indicator {
  padding: 5px 0;
}

/* Alert Content */
.alert-content {
  font-family: "Nunito Sans", sans-serif;
}

.alert-content p {
  margin-bottom: 8px;
}

/* Upload Area */
.upload-area {
  margin: 20px 0;
  transition: all 0.3s ease;
  border: 2px dashed #6e17a5;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  cursor: pointer;
  background-color: #f9f5fc;
}

.upload-area.drag-over {
  background-color: #eadcf3;
  border-color: #6e17a5;
  transform: scale(1.02);
}

.drop-zone-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "Nunito Sans", sans-serif;
  color: #2d0049;
}

.file-info {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Nunito Sans", sans-serif;
  color: #2d0049;
}

/* Card Styles (reutilizados de main_star_assignment_component) */
.avatarStyle {
  background-color: white !important;
}

.icon-item {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.cardStyle {
  border: 3px solid;
  border-color: #f2b37b;
  border-radius: 15px;
}

.cardStyle-gray {
  border: 3px solid #ccc;
  background-color: #f0f0f0;
  border-radius: 15px;
  color: #888;
}

.custom-font {
  font-size: 20px;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .step-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .step-number {
    margin-bottom: 8px;
  }

  .banner-title {
    font-size: 20px;
  }

  .banner-text {
    font-size: 14px;
  }
}

@media screen and (max-width: 550px) {
  .banner-title {
    font-size: 18px;
  }

  .banner-text {
    font-size: 13px;
  }

  .step-title {
    font-size: 18px;
  }

  .step-description {
    font-size: 14px;
  }
}

@media screen and (max-width: 425px) {
  .banner-title {
    font-size: 16px;
  }

  .banner-text {
    font-size: 12px;
  }

  .step-title {
    font-size: 16px;
  }
}
</style>
